module.exports = __webpack_public_path__ + "static/media/cheese2.6306272b.png";